module.exports = __webpack_public_path__ + "media/images/invite-members-9f52b95d530977351185510fbbabb3c3.svg";